/**
 * A painted colour as the `#rrggbb` a hex input can show. Handles the forms
 * the resolver and the browser hand back — `#rgb`, `#rrggbb`, `#rrggbbaa`,
 * `rgb()` and `rgba()` — and answers null for anything else (a named colour,
 * `transparent`, an oklch()), so the caller keeps the last hex it applied.
 */
export const cssColorToHex = (
  css: string | null | undefined,
): string | null => {
  if (!css) return null
  const value = css.trim().toLowerCase()
  const hex = value.match(/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/)
  if (hex) {
    const digits = hex[1]!
    if (digits.length === 3)
      return `#${digits
        .split('')
        .map((d) => d + d)
        .join('')}`
    return `#${digits.slice(0, 6)}`
  }
  const rgb = value.match(
    /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*[\d.]+\s*)?\)$/,
  )
  if (rgb) {
    const channel = (n: string) =>
      Math.min(255, Number(n)).toString(16).padStart(2, '0')
    return `#${channel(rgb[1]!)}${channel(rgb[2]!)}${channel(rgb[3]!)}`
  }
  return null
}
